<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: {
    userAccessByGenderAndAge: {
      type: Object,
      required: true
    },
    ages: {
      type: Array,
      default: () => []
    },
    age_settings: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [{
          label: this.$t('Analysis.User.male'),
          backgroundColor: '#009CE1',
          data: this.getDataForGender('male')
        },{
          label: this.$t('Analysis.User.female'),
          backgroundColor: '#99D7F3',
          data: this.getDataForGender('female')
        },{
          label: this.$t('Analysis.User.other'),
          backgroundColor: '#DDDDDD',
          data: this.getDataForGender('other')
        }]
      };
    },
    ages_internal() {
      if (!(this.ages instanceof Array) || this.ages.length === 0) {
        return this.age_settings.map(s => s.value);
      }
      return this.ages;
    },
    labels() {
      return this.ages_internal.map(v => this.age_settings.find(el => el.value === v).label);
    }
  },
  mounted() {
    this.options = {
      datalabels: {
        align: 'end',
        anchor: 'end',
        color: function(context) {
          return context.dataset.backgroundColor;
        },
        font: function(context) {
          var w = context.chart.width;
          return {
            size: w < 512 ? 12 : 14
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999"
          }
        }],
        xAxes: [{
          ticks: {
            display: true,
            min: 0
          },
          beforeFit: function (scale) {
            let maxValue = 0
            scale.chart.config.data.datasets.forEach(dataset => {
              if (dataset && dataset.data) {
                dataset.data.forEach(value => {
                  if (value > maxValue) {
                    maxValue = value
                  }
                })
              }
            })
            scale.options.ticks.max = maxValue + 2
          }
        }]
      },
      plugins: {
        datalabels: {
          display: true,
          align: 'end',
          anchor: 'end',
          color: '#AAA',
          font: function(context) {
            return {
              size: 10
            }
          }
        }
      },
      tooltips: {
        filter: function(tooltip) {
          return tooltip.value !== 'NaN'
        }
      }
    }
    this.checkHaveData()
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    getDataForGender: function(gender) {
      if (this.userAccessByGenderAndAge[gender] === undefined) {
        return this.ages_internal.map(l => 0);
      }
      const values = this.ages_internal.map(l => this.userAccessByGenderAndAge[gender][l]);
      return values;
    },
    checkEmpty: function()
    {
      return Object.values(this.userAccessByGenderAndAge).every(v => Object.keys(v).length === 0)
    },
    checkHaveData: function () {
      if (this.checkEmpty()) {
        this.options.plugins.datalabels.display = false
      }
    }
  },
  watch: {
    ages() {
      this.checkHaveData()
      this.renderChart(this.chartData, this.options);
    },
    userAccessByGenderAndAge() {
      this.checkHaveData()
      this.renderChart(this.chartData, this.options);
    }
  }
}
</script>
